import * as React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
const SvgArrowUp = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    props,
    <path d="M12.707 8.707a1 1 0 0 0-1.414 0l-4.588 4.588a.998.998 0 0 0 1.41 1.411L12 10.83l3.885 3.876a.998.998 0 0 0 1.41-1.411l-4.588-4.588Z" />
  )
export default SvgArrowUp
